import {useLocation} from 'react-router-dom';
import {Button} from '../../ui/buttons/button';
import {AuthLayout} from './auth-layout/auth-layout';
import {Trans} from '../../i18n/trans';
import {StaticPageTitle} from '../../seo/static-page-title';
import {useSettings} from '../../core/settings/use-settings';
import {useBootstrapData} from '../../core/bootstrap-data/bootstrap-data-context';
import {BootstrapData} from '../../core/bootstrap-data/bootstrap-data';

// SpiritWeb Static: the login page for everyone but ?bypass_sso=1 (SSO stage 2
// PART 5). /sso/login is a server route, so this is a plain anchor, never a
// router link. sso_error is added by App\Services\SsoBootstrapData.
export function SsoLoginPage() {
  const {pathname} = useLocation();
  const {branding} = useSettings();
  const {data} = useBootstrapData();
  const {sso_error: error} = data as BootstrapData & {sso_error?: string | null};

  const heading = pathname.includes('workspace') ? (
    <Trans
      values={{siteName: branding?.site_name}}
      message="To join your team on :siteName, sign in with The Spiritual Agency"
    />
  ) : (
    <Trans message="Sign in to SpiritWeb Static" />
  );

  return (
    <AuthLayout heading={heading}>
      <StaticPageTitle>
        <Trans message="Login" />
      </StaticPageTitle>
      {error && (
        <div role="alert" className="mb-20 text-sm text-danger">
          {error}
        </div>
      )}
      <Button
        className="block w-full"
        elementType="a"
        href="/sso/login"
        variant="flat"
        color="primary"
        size="md"
      >
        <Trans message="Sign in with The Spiritual Agency" />
      </Button>
      <div className="mt-12 text-center text-xs text-muted">
        <Trans message="One account for every Spiritual Agency app." />
      </div>
    </AuthLayout>
  );
}
